import SpinnerContainer from './SpinnerContainer'
import Spinner from './Spinner'

const Loading = () => (
  <SpinnerContainer>
    <Spinner />
  </SpinnerContainer>
)

export default Loading
